import React from 'react'
import { FaTrash } from 'react-icons/fa'
import cn from 'classnames'

import 'components/graph/controls/controls.less'

type RemoveShapeControlProps = {
  onClick: () => void
  disabled?: boolean
}

const RemoveShapeControl = ({ onClick, disabled }: RemoveShapeControlProps) => {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault()
    if (disabled) return
    onClick()
  }

  return (
    <div className={cn('control', 'remove-shape')} data-graph-type="control" title="Remove shape">
      <a className={cn('icon', { disabled })} onClick={handleClick}>
        <FaTrash aria-hidden />
        <span className="sr-only">Remove shape</span>
      </a>
    </div>
  )
}

export default RemoveShapeControl
